import { gsap } from 'gsap';

export interface IFacadeGalleryFilterValues {
  planValue: string;
  facadeValue: string;
  extColorValue: string;
}

export const facadeGalleryFilters: IFacadeGalleryFilterValues = {
  planValue: 'all',
  facadeValue: 'all',
  extColorValue: 'all',
};

export function updateFilters() {
  // Scroll to the top of the asset content container using GSAP
  const assetContent = document.getElementById('js-facade-gallery-images'); // Replace with your actual container ID
  if (assetContent) {
    const rect = assetContent.getBoundingClientRect();
    const offsetY = window.scrollY + rect.top - window.innerHeight * 0.3; // 30% of the viewport height
    gsap.to(window, {
      duration: 0.5,
      scrollTo: { y: offsetY, autoKill: false }, // Smoothly scroll to the calculated position
      ease: 'power2.out',
    });
  } else {
    return;
  }

  const figures = assetContent.querySelectorAll('figure');

  figures.forEach(figure => {
    const tags = figure.getAttribute('data-tags')?.split(' ');

    const matches =
      (facadeGalleryFilters.planValue === 'all' ||
        tags?.includes(`${facadeGalleryFilters.planValue}`)) &&
      (facadeGalleryFilters.facadeValue === 'all' ||
        tags?.includes(`${facadeGalleryFilters.facadeValue}`)) &&
      (facadeGalleryFilters.extColorValue === 'all' ||
        tags?.includes(`${facadeGalleryFilters.extColorValue}`));

    // Show or hide the figure based on the match
    figure.style.display = matches ? 'block' : 'none';
  });
}

export function resetAllFilters() {
  // Reset the filter values to 'all'
  facadeGalleryFilters.planValue = 'all';
  facadeGalleryFilters.facadeValue = 'all';
  facadeGalleryFilters.extColorValue = 'all';

  // Update button states: remove 'active' from all buttons, and add 'active' to "All" buttons
  const panelContainer = document.getElementById('js-facade-gallery-images');

  if (panelContainer) {
    const allFilterButtons = panelContainer.querySelectorAll('.js-btn-filter');
    allFilterButtons.forEach(button => button.classList.remove('active'));

    // Find the "All" buttons and set them as active
    const allButtons = panelContainer.querySelectorAll(
      '.js-btn-filter[data-filter="all"]',
    );
    allButtons.forEach(button => button.classList.add('active'));
  }

  // Update the filters for the specified panel
  updateFilters();
}
